import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledDateSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 1rem;
    background: ${pickThemeColor('BG_SECONDARY')};
  }
`;

export const StyledSectionList = styled.div`
  gap: 0;
  border-left: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    max-width: 64rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledSectionTitle = styled.div`
  ${pickThemeFontStyles('12', '20', 'SEMI_BOLD')};
  color: ${pickThemeColor('DARK_GREEN')};
`;

export const StyledListTitle = styled.div`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
`;
